import {Model} from '@/models/model';
import {Type} from '@/models/type';

export class Output extends Model {
    cast_type(rawType, rawAttributes) {
        return rawType instanceof Type ? rawType : new Type({...rawType, _node: rawAttributes._node});
    }

    get subOutputs() {
        let properties = this.type.properties || [];

        if (this.type.descriptor) {
            properties = this.type.descriptor.describe(this.node);
        }

        return properties.map(property => new Output({...property, group: this.path, _parent: this, _node: this.node}))
    }

    get path() {
        return `${this.group || ''}.${this.id}`;
    }

    get ref() {
        return `{${this.path}${this.transform ? '|' + this.transform : ''}}`;
    }
}
